export default __webpack_public_path__ + "static/media/rank2.ee77fb14.png";